import axios from 'axios';


// A porta depende de estarmos em produção ou no modo desenvolvimento
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});


export default api;